import Page from "framework/ui/content/Page";
import Head from "framework/ui/content/Head";
import NavBar from "framework/ui/content/NavBar";
import icon from "./assets/icon.png";
import PageContent from "framework/ui/content/PageContent";
import Breadcrumbs from "framework/ui/content/Breadcrumbs";
import PageTitle from "framework/ui/content/PageTitle";
import PageSections from "framework/ui/content/PageSections";
import GuestBook from "framework/ui/guestbook/GuestBook";
import Copyright from "framework/ui/content/Copyright";
import Gallery from "framework/ui/gallery/Gallery";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Head/>
      <NavBar icon={icon} expand={'sm'} brand={''}/>
      <PageContent>
        <Breadcrumbs/>
        <PageTitle/>
        <PageSections/>
        <Gallery galleryId={942} pageId={12705}/>
        <Gallery galleryId={933} pageId={12706}/>
        <Gallery galleryId={444} pageId={12707}/>
        <Gallery galleryId={424} pageId={12708}/>
        <Gallery galleryId={417} pageId={12709}/>
        <Gallery galleryId={426} pageId={12710}/>
        <Gallery galleryId={427} pageId={12711}/>
        <Gallery galleryId={428} pageId={12712}/>
        <Gallery galleryId={443} pageId={12713}/>
        <Gallery galleryId={0} pageId={12712}/>
        <GuestBook guestBookId={113} pageId={2380}/>
      </PageContent>
      <Copyright startYear={'2005'}/>
    </Page>
  )
}